export default { 
    error: {
        back_to_main_page : "กลับสู่หน้าหลัก", 
        return_main_page: "กรุณากลับสู่หน้าหลัก เพื่อทำรายการใหม่อีกครั้ง",
    }, 
}
